import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'leaflet/dist/leaflet.css'
import './src/styles/styles.scss'
import 'animate.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import 'react-image-gallery/styles/css/image-gallery.css'
import { wrapRootElement as wrapRootElementBrowser } from './src/wrapElements'
import { wrapPageElement as wrapPageElementBrowser } from './src/wrapElements'

import 'react-checkbox-tree/lib/react-checkbox-tree.css'

export const wrapRootElement = wrapRootElementBrowser
export const wrapPageElement = wrapPageElementBrowser

import { hydrateRoot } from 'react-dom/client'

export const replaceHydrateFunction = () => {
  return (element: React.ReactElement, container: HTMLElement) => {
    return hydrateRoot(container, element, {
      onRecoverableError(error: unknown, info?: { componentStack?: string }) {
        console.group('Hydration mismatch')
        console.error(error)
        if (info?.componentStack) {
          // 👇 Esto te muestra la traza de componentes (el árbol dueño del mismatch)
          console.log(info.componentStack)
        }
        console.groupEnd()
      },
    })
  }
}

// export const onInitialClientRender = () => {
//   window.addEventListener('popstate', () => (window.location.href = window.location.href))
// }
